import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import api from '../services/api';
import './FAQs.css';

const FAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await api.get('/faqs');
        const data = response.data;
        setFaqs(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to fetch FAQs', err);
        setError(err.response?.data?.message || 'Failed to load FAQs.');
        setFaqs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <Layout>
      <PageMeta
        title="FAQs"
        description="Frequently asked questions about FM Ultratech Farms – products, orders, shipping, and more."
      />
      <div className="faqs-page">
        <div className="faqs-hero">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about our products and services.</p>
        </div>
        <div className="faqs-content">
          <div className="faqs-container">
            {loading ? (
              <p className="faqs-loading">Loading FAQs...</p>
            ) : error ? (
              <p className="faqs-error">{error}</p>
            ) : faqs.length === 0 ? (
              <p className="faqs-empty">No FAQs available at the moment. Please check back later or contact us.</p>
            ) : (
              <ul className="faqs-list">
                {faqs.map((faq) => (
                  <li key={faq.id} className={`faqs-item ${openId === faq.id ? 'faqs-item--open' : ''}`}>
                    <button
                      type="button"
                      className="faqs-question"
                      onClick={() => toggle(faq.id)}
                      aria-expanded={openId === faq.id}
                    >
                      <span>{faq.question}</span>
                      <span className="faqs-icon" aria-hidden="true">
                        {openId === faq.id ? '−' : '+'}
                      </span>
                    </button>
                    <div className="faqs-answer-wrapper">
                      <div className="faqs-answer">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FAQs;
